import { isNumber, isString } from "../utils/schemaUtils";

export interface LinearInitiative {
  id: string;
  name: string;
  description?: string;
  status: string;
  targetDate?: string;
  projectCount: number;
  url: string;
}

const isLinearInitiative = (v: unknown): v is LinearInitiative => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    (r.description === undefined || isString(r.description)) &&
    isString(r.status) &&
    (r.targetDate === undefined || isString(r.targetDate)) &&
    isNumber(r.projectCount) &&
    isString(r.url)
  );
};

export interface LinearInitiativesPayload {
  type: "linear_initiatives";
  initiatives: LinearInitiative[];
}

export const parseLinearInitiativesPayload = (v: unknown): LinearInitiativesPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_initiatives") return null;
  if (!Array.isArray(r.initiatives) || !r.initiatives.every(isLinearInitiative)) return null;
  return {
    type: "linear_initiatives",
    initiatives: r.initiatives,
  };
};
